<template>
  <div>
    <v-list two-line class="t-documents-list">
      <template v-for="(document, index) in content">
        <div :key="index">
          <v-divider></v-divider>
          <v-list-tile
            v-touch:swipe.left="swipeLeftHandler(index)"
            v-touch:swipe.right="swipeRightHandler"
          >
            <v-list-tile-content @click="openDocument(document)">
              <v-list-tile-title>{{ document.doc_title }} № {{ document.doc_id}}</v-list-tile-title>
              <v-list-tile-sub-title>{{ document.created_on }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="text--primary">{{ document.summa }} <span
                class="grey--text currency">{{currencies[document.valuti_id]}}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-slide-x-reverse-transition>
              <v-list-tile-action v-show="showAction === index"
                                  v-if="allowEditList.indexOf(document.name) > - 1">
                <v-btn color="grey" @click="openCatalog(document)">
                  <v-icon
                    color="white"
                  >
                    mdi-plus
                  </v-icon>
                </v-btn>
                <v-btn color="red" @click="openDeleteConfirmationModal(document); showAction = null">
                  <v-icon
                    color="white"
                  >
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-slide-x-reverse-transition>
          </v-list-tile>
        </div>
      </template>
      <v-divider v-if="content.length"></v-divider>
    </v-list>
  </div>
</template>

<script>
import documentsDisplay from '../mixins/documentsDisplay'

export default {
  name: 'DocumentsList',
  mixins: [
    documentsDisplay
  ],
  data () {
    return {
      showAction: null
    }
  },
  methods: {
    swipeLeftHandler (param) {
      return (direction) => {
        this.showAction = param
      }
    },
    swipeRightHandler () {
      this.showAction = null
    }
  }
}
</script>

<style scoped>

</style>
